import React from 'react';
import DataResource from '../../common/v4/DataResource'
import Panel from '../../common/layout/Panel'


export default class extends React.Component {
    render () {
        const data = {
            url: `/admin/reports/payments`,
            data: {
                data: [],
                metadata: []
            },
            userfilter:
            [
                {
                    source: 'ATRPMNTDATE',
                    label: 'Payment Date',
                    type: 'date_range',
                    default: {'from' : new Date(), 'to': new Date() }
                }
            ],
            userFilterExpandable: true,
            userFilterSimple: true,
            metadata: [
                {
                    label: 'id',
                    source: 'ATRPAYID',
                    type: 'primary',
                    editable: false,
                    visible: false
                },
                {
                    label: 'Client',
                    source: 'ATRACCTIDOUT',
                    type: 'select',
                    editable: false,
                    visible: true,
                },
                {
                    label: 'Amount',
                    source: 'ATRAMNT',
                    type: 'text',
                    editable: false,
                    default: '0.00',
                    placeholder: '0.00'
                },
                {
                    label: 'Currency',
                    source: 'ATRCURID',
                    type: 'select',
                    editable: false,
                    visible: true,
                    default: '1'
                },
                {
                source: 'ATRPMNTDESCR',
                label: 'Description',
                type: 'text',
            },
            {
                source: 'ATRREFID',
                label: 'Reference',
                type: 'text',
            },
            {
                source: 'ATRPMNTDATE',
                label: 'Paid At',
                type: 'date',
            },
            {
                source: 'created_at',
                label: 'Posted At',
                type: 'date',
            },
            ]
        }
        return (
            <Panel title = "Payment List">
                <DataResource
                    data = {data}
                    {...this.props} 
                    disableAdd
                    pagination
                />
            </Panel>
        )
    }
}